import type { CargaSubbarProps } from "./types-carga-subbar";
import { CargaSubbarView } from "./view-carga-subbar";

/** Chips dos filtros aplicados à esquerda e a legenda à direita. */
export function CargaSubbar(props: CargaSubbarProps) {
  return <CargaSubbarView {...props} />;
}

export type * from "./types-carga-subbar";
